const login = () =>
    import(/* webpackChunkName: "login" */ "@/views/login/login");
const registerGetCode = () =>
  import(
    /* webpackChunkName: "register-getCode" */ "@/views/login/register-getCode/"
  );
const registerSubmit = () =>
  import(
    /* webpackChunkName: "register-submit" */ "@/views/login/register-submit/"
  );
const registerStatus = () =>
  import(
    /* webpackChunkName: "register-status" */ "@/views/login/register-status/"
  );
const forget = () =>
  import(/* webpackChunkName: "forget" */ "@/views/login/forget/");
const forgetReset = () =>
  import(/* webpackChunkName: "forget-reset" */ "@/views/login/forget-reset/");
const forgetStatus = () =>
  import(
    /* webpackChunkName: "forget-status" */ "@/views/login/forget-status/"
  );
const autoLogin = () =>
  import(/* webpackChunkName: "auto-login" */ "@/views/login/auto-login/");
const initStorage = () =>
  import(
    /* webpackChunkName: "auto-login" */ "@/views/login/auto-login/init-storage"
  );
const agreement = () => import("@/views/login/agreement/index.vue");
const _success = () => import("@/views/login/forget/success.vue");
export default [
  {
    path: "/login",
    name: "login",
    meta: { title: "登录" },
    component: login
  },
  {
    path: "/login/registerGetCode",
    name: "registerGetCode",
    meta: { title: "注册" },
    component: registerGetCode
  },
  {
    path: "/login/registerSubmit",
    name: "registerSubmit",
    meta: { title: "注册" },
    component: registerSubmit
  },
  {
    path: "/login/registerStatus/:status",
    name: "registerStatus",
    meta: { title: "注册结果" },
    props: true,
    component: registerStatus
  },
  {
    path: "/login/forget/:type",
    name: "forget",
    meta: { title: "忘记密码" },
    component: forget
  },
  {
    path: "/login/forget/reset",
    name: "forgetReset",
    meta: { title: "重置密码" },
    component: forgetReset
  },
  {
    path: "/login/forget/reset/:status",
    name: "forgetStatus",
    meta: { title: "重置结果" },
    props: true,
    component: forgetStatus
  },
  {
    path: "/login/auto-login/:access_token/:return_url?",
    name: "autoLogin",
    meta: { title: "自动登录" },
    props: true,
    component: autoLogin
  },
  {
    path: "/login/init-storage/:params",
    name: "initStorage",
    meta: { title: "初始化" },
    props: true,
    component: initStorage
  },
  {
    path: "/agreement",
    name: "agreement",
    meta: { title: "用户协议" },
    component: agreement
  },
  {
    path: "/privacy-agreement",
    name: "privacy-agreement",
    meta: { title: "隐私协议" },
    component: () => import("@/views/login/agreement/privacy-agreement.vue")
  },
  {
    path: "/success",
    name: "success",
    meta: { title: "操作成功" },
    component: _success
  },
  {
    path: "/identity",
    name: "identity",
    meta: { title: "身份验证" },
    component: () => import("@/views/login/identity/identity.vue")
  },
  {
    path: "/identity/verify",
    name: "identity_verify",
    meta: { title: "身份验证" },
    component: () => import("@/views/login/identity/verify.vue")
  },
  {
    path: "/login/sso",
    name: "sso",
    meta: { title: "单点登录" },
    component: () => import("@/views/login/sso.vue")
  },
  {
    path:"/agent_code_not_found",
    name: "agent_code_not_found",
    meta: { title: "错误提示" },
    component: () => import("@/views/login/login-err.vue")
  }
];
